import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyInsuranceIllustration = lazy(() => import('./svg-components/insurance-illustration'));

const InsuranceIllustration = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyInsuranceIllustration {...rest} />
  </Suspense>
);

export default InsuranceIllustration;
